import MainDocument from 'presentations/views/components/MainDocument';
import { GetServerSideProps } from 'next';
import SecurityPolicyPage from 'presentations/views/components/pages/SecurityPolicyPage';
import Header from 'presentations/views/components/organisms/Header';
import Breadcrumbs from 'presentations/views/components/organisms/Breadcrumbs';
import { setBreadcrumbs } from 'presentations/views/helpers/breadcrumbs';
import {
  apiPath,
  securityPolicyPath,
  termsPath,
  webPath,
} from 'presentations/routes/path';
import { get } from 'infras/rest_client';
import { useContext } from 'react';
import { ServicePortalContext } from 'presentations/reducers/ServicePortal';
import { StaticPageItem } from 'presentations/api/schema/contents';

interface ServerProps {
  item: StaticPageItem;
  linkCanonical: string;
}

export const getServerSideProps: GetServerSideProps = async ({
  locale,
  params,
}: any) => {
  const result = await get(
    apiPath(`/v1/contents/static_pages/security`, {
      locale,
    }),
  );
  if (!result.isSuccess) {
    return { notFound: true };
  }
  if (!result.data) {
    return { notFound: true };
  }

  const item: StaticPageItem = result.data;
  const props: ServerProps = {
    item,
    linkCanonical: webPath(securityPolicyPath(), locale),
  };
  return {
    props,
  };
};

export default function Page(props: ServerProps) {
  const { state: serviceState } = useContext(ServicePortalContext);
  const viewer = serviceState.viewer;

  const breadcrumbs = [];
  breadcrumbs.push({ title: props.item.title, link: securityPolicyPath() });
  const routes = setBreadcrumbs(breadcrumbs);

  return (
    <MainDocument title={props.item.title} linkCanonical={props.linkCanonical}>
      <SecurityPolicyPage
        header={<Header viewer={viewer} />}
        breadcrumbs={<Breadcrumbs routes={routes} />}
        title={props.item.title}
        content={props.item.content}
      />
    </MainDocument>
  );
}
